(() => {
  const root = document.documentElement;
  root.classList.add('wo-premium-ready');

  // Future WildOpeningTCG interactions live here.
  // Do not override Dawn global.js, product-info.js, cart, product forms or media gallery.

  function initWoAnnouncementTicker() {
    const tickers = document.querySelectorAll('[data-wo-ticker]');

    tickers.forEach((ticker) => {
      const track = ticker.querySelector('[data-wo-ticker-track]');
      const sourceGroup = ticker.querySelector('[data-wo-ticker-group]');

      if (!track || !sourceGroup) return;

      const setup = () => {
        // Remove old clones
        track.querySelectorAll('[data-wo-ticker-clone]').forEach((clone) => clone.remove());

        // Pause animation and reset transform while measuring
        track.style.animation = 'none';
        track.style.transform = 'translate3d(0, 0, 0)';

        // Force layout recalc before measuring
        void track.offsetWidth;

        const groupWidth = Math.ceil(sourceGroup.getBoundingClientRect().width);
        const tickerWidth = Math.ceil(ticker.getBoundingClientRect().width);

        if (!groupWidth || !tickerWidth) return;

        // Clone until track covers at least 3× the ticker viewport width, minimum 4 clones
        const minTrackWidth = tickerWidth * 3;
        let currentWidth = groupWidth;
        let clonesNeeded = 0;

        while (currentWidth < minTrackWidth || clonesNeeded < 4) {
          const clone = sourceGroup.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-wo-ticker-clone', 'true');
          clone.removeAttribute('data-wo-ticker-group');
          track.appendChild(clone);
          currentWidth += groupWidth;
          clonesNeeded += 1;
        }

        // Set exact pixel distance = one group width
        ticker.style.setProperty('--wo-ticker-distance', `${groupWidth}px`);

        // Stable speed ~80px/s, clamped between 18s and 42s
        const duration = Math.max(18, Math.min(42, groupWidth / 80));
        ticker.style.setProperty('--wo-ticker-duration', `${duration}s`);

        // Resume animation on next frame
        requestAnimationFrame(() => {
          track.style.animation = '';
          track.style.transform = '';
        });
      };

      setup();

      let resizeTimer;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(setup, 150);
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(setup).catch(() => {});
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWoAnnouncementTicker);
  } else {
    initWoAnnouncementTicker();
  }
})();
